import Header from '../../../components/Header';
import Footer from '../../../components/Footer/Footer';
import { FWNavbar } from '../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Modal } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';
import ModalContent from './assets/ModalContent';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

const SiteMap = () => {
	const location = useLocation();

	const [modal, setModal] = useState({
		title: '',
		content: '',
	});
	const [showModal, setShowModal] = useState(false);
	const handleShowModal = (title, content) => {
		setModal({ title: title, content: content });
		setShowModal(true);
	};

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const activeTab = queryParams.get('tab');

		if (activeTab) {
			setActiveKey(activeTab);
		}
	}, [location]);

	const [activeKey, setActiveKey] = useState('Maintenance Overview');
	return (
		<>
			<Header plant="warren" />
			<main>
				<wrapper class="section-wrapper">
					<FWNavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Site Map</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<h2>WTAP SITE MAP</h2>

							<div class="d-flex flex-wrap site-map">
								<div>
									<section>
										<h4 style={{ background: 'green', color: '#fff' }}>PowerPaint HMI</h4>
										<ul>
											<li>
												<b>Introduction to SMARTInspect</b>
												<ul>
													<a href="#">
														<li onClick={() => handleShowModal('Introduction to SMARTInspect', 'intro')}>Introduction to SMARTInspect</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Configuration File Setup', 'config-setup')}>Configuration File Setup</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Manual Stop / Start Procedure', 'start-stop')}>Manual Stop / Start Procedure</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Server Power Shutdown / Startup', 'startup-shutdown')}>Server Power Startup / Shutdown</li>
													</a>
												</ul>
											</li>

											<li>
												<b>Cell Overview</b>
												<ul>
													<a href="#">
														<li onClick={() => handleShowModal('Side-by-Side View', 'horizontal-layout')}>Side-by-Side View</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Top-Bottom View', 'vertical-layout')}>Top-Bottom View</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Plugin Menu', 'plugin-menu')}>Plugin Menu</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Service Sidebar', 'service-sidebar')}>Sidebar Service Monitor</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Camera Status Sidebar', 'quick-cam-status')}>Camera Status Sidebar</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Fault Alert Bar', 'fault-viewer')}>Fault Alert Bar</li>
													</a>
												</ul>
											</li>

											<li>
												<b>Monitoring Plugins</b>
												<ul>
													<a href="#">
														<li onClick={() => handleShowModal('All Camera Status', 'camera-status')}>All Camera Status</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Job Queue', 'job-queue')}>Job Queue</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Service Process Viewer', 'service-process-viewer')}>Service Process Monitor</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Server Process Monitor', 'server-process-monitor')}>Server Process Monitor</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Service Monitor', 'service-monitor')}>Service Monitor</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Reports Plugins</b>
												<ul>
													<a href="#">
														<li onClick={() => handleShowModal('Scans Report', 'scans')}>Scans Report</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Scan Rate', 'scan-rate')}>Scan Rate</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Defects', 'defects')}>Defects</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Defect Detail', 'defect-detail')}>Defect Detail</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Faults', 'faults')}>Faults</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Offline Services', 'offline-services')}>Offline Services</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Change Log', 'change-log')}>Change Log</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Qvs Fault Viewer', 'QVS-fault-viewer')}>Qvs Fault Viewer</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Qvs Scan History', 'QVS-scan-history')}>Qvs Scan History</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Configuration Plugins</b>
												<ul>
													<a href="#">
														<li onClick={() => handleShowModal('Hot Spot Editor', 'hotspot')}>Hot Spot Editor</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Style Setup and Plant Color Setup', 'style-setup')}>Style Set-Up</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Style Setup and Plant Color Setup', 'style-setup')}>Plant Color Set-Up</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Style Setup and Plant Color Setup', 'plant-color')}>Plant Color Family Set-Up</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Plant Camera Override Setup', 'plant-camera-override')}>Plant Camera Override Set-Up</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('JSON Editor', 'json-editor')}>JSON Editor</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Utility Plugins</b>
												<ul>
													<a href="#">
														<li onClick={() => handleShowModal('Defect Heat Map', 'defect-map')}>Defect Heat Map</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Network Diagnostic', 'network-diagnostic')}>Network Diagnostic</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Basic User Setup', 'user-setup')}>New User Set-Up</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('PLC IO', 'plc-io')}>PLC I/O</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Baseline Setup', 'baseline-setup')}>Baseline Setup</li>
													</a>
													<a href="#">
														<li onClick={() => handleShowModal('Calculator', 'calculator')}>Calculator</li>
													</a>
												</ul>
											</li>
											<li>
												<b>System Recovery</b>
												<ul>
													<a href="#">
														<li onClick={() => handleShowModal('System Recovery', 'recovery-screen')}>System Recovery</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Help</b>
												<ul>
													<a href="#">
														<li onClick={() => handleShowModal('About', 'about')}>About</li>
													</a>
												</ul>
											</li>
										</ul>
									</section>
									<section>
										<h4 className="safety-element">Safety</h4>
										<ul>
											<li>
												<b>Safety Overview</b>
												<ul>
													<a href="/smart-inspect/warren/safety/safety-overview/?tab=Notices">
														<li>Notices</li>
													</a>
													<a href="/smart-inspect/warren/safety/safety-overview/?tab=Safety Overview">
														<li>Safety Overview</li>
													</a>
													<a href="/smart-inspect/warren/safety/safety-overview/?tab=General Safety">
														<li>General Safety</li>
													</a>
													<a href="/smart-inspect/warren/safety/safety-overview/?tab=Personal Safety">
														<li>Personal Safety</li>
													</a>
													<a href="/smart-inspect/warren/safety/safety-overview/?tab=Work Area Safety">
														<li>Work Area Safety</li>
													</a>
													<a href="/smart-inspect/warren/safety/safety-overview/?tab=LOTO">
														<li>Lockout / Tagout Placard</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Control Safety</b>
												<ul>
													<a href="/smart-inspect/warren/safety/controls-safety/?tab=Electrical Safety">
														<li>Electrical Safety</li>
													</a>
													<a href="/smart-inspect/warren/safety/controls-safety/?tab=Mechanical Safety">
														<li>Mechanical Safety</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Safety Devices</b>
												<ul>
													<a href="/smart-inspect/warren/safety/safety-devices">
														<li>Emergency Stop Pushbuttons</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Equipment Lockout</b>
												<ul>
													<a href="/smart-inspect/warren/safety/equipment-lockout/">
														<li>Equipment Lockout</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Energy Sources</b>
												<ul>
													<a href="/smart-inspect/warren/safety/energy-sources/">
														<li>PDP Main Power Disconnect</li>
													</a>
												</ul>
											</li>
										</ul>
									</section>

									<section>
										<h4 className="equipment-element">Equipment</h4>
										<ul>
											<li>
												<b>Equipment Overview</b>
												<ul>
													<a href="/smart-inspect/warren/equipment/equipment-overview/?tab=SMARTInspect Layout">
														<li>SMARTInspect Layout</li>
													</a>
													<a href="/smart-inspect/warren/equipment/equipment-overview/?tab=Sequence of Operations">
														<li>Sequence of Operations</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Assemblies</b>
												<ul>
													<a href="/smart-inspect/warren/equipment/assemblies/?tab=Inspection Frame Assembly">
														<li>Inspection Frame Assembly</li>
													</a>
													<a href="/smart-inspect/warren/equipment/assemblies/?tab=Camera Mounting Assemblies">
														<li>Camera Mounting Assemblies</li>
													</a>
													<a href="/smart-inspect/warren/equipment/assemblies/?tab=Camera Assemblies">
														<li>Camera Assemblies</li>
													</a>
													<a href="/smart-inspect/warren/equipment/assemblies/?tab=Lighting Assemblies">
														<li>Lighting Assemblies</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Electrical Panels</b>
												<ul>
													<a href="/smart-inspect/warren/equipment/electrical-panels/?tab=PDP">
														<li>PDP</li>
													</a>
													<a href="/smart-inspect/warren/equipment/electrical-panels/?tab=Transformer Stand">
														<li>Transformer Stand</li>
													</a>
													<a href="/smart-inspect/warren/equipment/electrical-panels/?tab=PAC">
														<li>PAC</li>
													</a>
													<a href="/smart-inspect/warren/equipment/electrical-panels/?tab=Server Panel">
														<li>Server Panel</li>
													</a>
													<a href="/smart-inspect/warren/equipment/electrical-panels/?tab=Trigger Panels">
														<li>Trigger Panels</li>
													</a>
												</ul>
											</li>
											<li>
												<b>System Control</b>
												<ul>
													<a href="/smart-inspect/warren/equipment/system-control/?tab=HMI">
														<li>HMI</li>
													</a>
													<a href="/smart-inspect/warren/equipment/system-control/?tab=Buttons and Indicators">
														<li>Buttons and Indicators</li>
													</a>
													<a href="/smart-inspect/warren/equipment/system-control/?tab=Inspection Monitor">
														<li>Inspection Monitor</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Part / Skid Detect</b>
												<ul>
													<a href="/smart-inspect/warren/equipment/part-detect/?tab=Encoder Wheel Line Trackers">
														<li>Encoder Wheel Line Trackers</li>
													</a>
													<a href="/smart-inspect/warren/equipment/part-detect/?tab=AB Skid Detect Switch Bracket">
														<li>AB Skid Detect Switch Bracket</li>
													</a>
													<a href="/smart-inspect/warren/equipment/part-detect/?tab=Part Detect Photoeye Assembly">
														<li>Part Detect Photoeye Assembly</li>
													</a>
												</ul>
											</li>
										</ul>
									</section>
								</div>

								<div>
									<section>
										<h4 className="maintenance-element">Maintenance</h4>
										<ul>
											<li>
												<b>Maintenance Overview</b>
												<ul>
													<a href="/smart-inspect/warren/maintenance/maintenance-overview/">
														<li>Maintenance Overview</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Maintenance Safety</b>
												<ul>
													<a href="/smart-inspect/warren/maintenance/maintenance-safety/?tab=General Maintenance Safety">
														<li>General Maintenance Safety</li>
													</a>
													<a href="/smart-inspect/warren/maintenance/maintenance-safety/?tab=Mechanical Maintenance Safety">
														<li>Mechanical Maintenance Safety</li>
													</a>
													<a href="/smart-inspect/warren/maintenance/maintenance-safety/?tab=Electrical Maintenance Safety">
														<li>Electrical Maintenance Safety</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Maintenance Lockout Procedure</b>
												<ul>
													<a href="/smart-inspect/warren/maintenance/maintenance-lockout/?tab=Maintenance Lockout">
														<li>Maintenance Lockout</li>
													</a>
													<a href="/smart-inspect/warren/maintenance/maintenance-lockout/?tab=Maintaining Safety Features">
														<li>Maintaining Safety Features</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Preventive Maintenance</b>
												<ul>
													<a href="/smart-inspect/warren/maintenance/preventive-maintenance/">
														<li>Preventive Maintenance Tasks</li>
													</a>
												</ul>
											</li>
											<li>
												<b>OEM Maintenance</b>
												<ul>
													<a href="/smart-inspect/warren/maintenance/oem-maintenance/">
														<li>OEM General Maintenance</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Maintenance Procedures</b>
												<ul>
													<a href="/smart-inspect/warren/maintenance/maintenance-procedures/?tab=ALLIED Camera Replacement">
														<li>ALLIED Camera Replacement</li>
													</a>
													<a href="/smart-inspect/warren/maintenance/maintenance-procedures/?tab=Channel Board Replacement">
														<li>Channel Board Replacement</li>
													</a>
													<a href="/smart-inspect/warren/maintenance/maintenance-procedures/?tab=Trigger Board Replacement">
														<li>Trigger Board Replacement</li>
													</a>
													<a href="/smart-inspect/warren/maintenance/maintenance-procedures/?tab=Light Arch Replacement">
														<li>Light Arch Replacement</li>
													</a>
													<a href="/smart-inspect/warren/maintenance/maintenance-procedures/?tab=Lights 1-8 Replacement">
														<li>Lights 1-8 Replacement</li>
													</a>
													<a href="/smart-inspect/warren/maintenance/maintenance-procedures/?tab=Lights 2-5 Replacement">
														<li>Lights 2-5 Replacement</li>
													</a>
													<a href="/smart-inspect/warren/maintenance/maintenance-procedures/?tab=Double Wide Lights Replacement">
														<li>Double Wide Lights Replacement</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Machine Ledgers</b>
												<ul>
													<a href="/smart-inspect/warren/maintenance/machine-ledgers/">
														<li>Machine Ledgers</li>
													</a>
												</ul>
											</li>
										</ul>
									</section>
									<section>
										<h4 className="troubleshooting-element" style={{ color: '#fff' }}>
											Troubleshoot
										</h4>
										<ul>
											<li>
												<b>Troubleshooting Overview</b>
												<ul>
													<a href="/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=Troubleshooting Overview">
														<li>Troubleshooting Overview</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=Troubleshooting Guidelines">
														<li>Troubleshooting Guidelines</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=Experience">
														<li>Experience</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=Step-by-Step Approach">
														<li>Step-by-Step Approach</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=Intermittent Failures">
														<li>Intermittent Failures</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=Root Cause">
														<li>Root Cause</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=HMI">
														<li>HMI</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=Fault Recovery Procedure">
														<li>Fault Recovery Procedure</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/troubleshoot-overview/?tab=Troubleshooting Process">
														<li>Troubleshooting Process</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Mechanical Troubleshooting</b>
												<ul>
													<a href="/smart-inspect/warren/troubleshooting/mechanical-troubleshooting/">
														<li>Mechanical Troubleshooting</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Electrical Troubleshooting</b>
												<ul>
													<a href="/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Electrical Troubleshooting Overview">
														<li>Electrical Troubleshooting Overview</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Electrical Troubleshooting Procedure">
														<li>Electrical Troubleshooting Procedure</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Sequence Stops">
														<li>Sequence Stops</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Repairing Sensors">
														<li>Repairing Sensors</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Non-Actuating Problems">
														<li>Non-Actuating Problems</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Programmable Logic Controller (PLC)">
														<li>Programmable Logic Controller (PLC)</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=PLC Inputs">
														<li>PLC Inputs</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=PLC Outputs">
														<li>PLC Outputs</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=PLC Processor">
														<li>PLC Processor</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Allen Bradley GuardLogix">
														<li>Allen Bradley GuardLogix</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Control Panel">
														<li>Control Panel</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Proximity / Limit Switch">
														<li>Proximity / Limit Switch</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/electrical-troubleshooting/?tab=Electrical Device Inspection">
														<li>Electrical Device Inspection</li>
													</a>
												</ul>
											</li>
											<li>
												<b>OEM Troubleshooting</b>
												<ul>
													<a href="/smart-inspect/warren/troubleshooting/oem-troubleshooting/?tab=">
														<li>OEM Troubleshooting</li>
													</a>
												</ul>
											</li>
											<li>
												<b>SMARTInspect Troubleshooting</b>
												<ul>
													<a href="/smart-inspect/warren/troubleshooting/smart-inspect-troubleshooting/?tab=SMARTInspect Troubleshooting Overview">
														<li>SMARTInspect Troubleshooting Overview</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/smart-inspect-troubleshooting/?tab=PowerPaint Rendering Issues">
														<li>PowerPaint 'Rendering' Issues</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/smart-inspect-troubleshooting/?tab=Missing Configuration Files">
														<li>'Missing' Configuration Files</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/smart-inspect-troubleshooting/?tab=SQL Server Exceptions">
														<li>SQL Server Exceptions</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/smart-inspect-troubleshooting/?tab=Recovering from Fault State">
														<li>Recovering from Fault State</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/smart-inspect-troubleshooting/?tab=Finesse Deck Issues">
														<li>Finesse Deck Issues</li>
													</a>
												</ul>
											</li>
											<li>
												<b>Hardware Troubleshooting</b>
												<ul>
													<a href="/smart-inspect/warren/troubleshooting/hardware-troubleshooting/?tab=ALLIED Camera Troubleshooting">
														<li>ALLIED Camera Troubleshooting</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/hardware-troubleshooting/?tab=No LED / Channel Board Power">
														<li>No LED Light / Channel Board Power</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/hardware-troubleshooting/?tab=LED Board Not Illuminated">
														<li>LED Board Not Illuminated</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/hardware-troubleshooting/?tab=Suspected LED Trigger Problem">
														<li>Suspected LED Trigger Problem</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/hardware-troubleshooting/?tab=No Trigger Board Power">
														<li>No Trigger Board Power</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/hardware-troubleshooting/?tab=Suspected Encoder Signal Problem">
														<li>Suspected Encoder Signal Problem</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/hardware-troubleshooting/?tab=Suspected Part Detect Signal Problem">
														<li>Suspected Part Detect Signal Problem</li>
													</a>
													<a href="/smart-inspect/warren/troubleshooting/hardware-troubleshooting/?tab=Suspected Laser Photoeye Signal Problem">
														<li>Suspected Laser Photoeye Signal Problem</li>
													</a>
												</ul>
											</li>
										</ul>
									</section>

									<section>
										<h4 className="drawing-element" style={{ color: '#fff' }}>
											Drawings
										</h4>
										<ul>
											<a href="/smart-inspect/warren/drawings">
												<li>Drawings</li>
											</a>
										</ul>
									</section>
									<section>
										<h4 className="appendix-element" style={{ color: '#fff' }}>
											Appendix
										</h4>
										<ul>
											<a href="/smart-inspect/warren/appendix">
												<li>Appendix</li>
											</a>
										</ul>
									</section>
								</div>
							</div>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
			<Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName="course-modal" centered>
				<Modal.Header closeButton>
					<Modal.Title>{modal.title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<ModalContent content={modal.content} />
				</Modal.Body>
			</Modal>
		</>
	);
};

export default SiteMap;
